<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon"
        v-bind:show.sync="dialog"
        maxWidth="90%"
        :showRequiredFields="false"
        :showButton="false"
    >
        <template v-slot:form>
            <v-container>
                <!-- Alerta de token expirado/inválido (RN01) -->
                <v-row v-if="isFormBlocked">
                    <v-col cols="12">
                        <v-alert
                            :type="tokenExpired ? 'warning' : (alreadySigned ? 'info' : 'error')"
                            prominent
                            border="left"
                        >
                            <v-row align="center">
                                <v-col class="grow">
                                    <strong>{{ blockMessage }}</strong>
                                    <div v-if="tokenExpired" class="mt-2 text-body-2">
                                        O prazo para acessar este link expirou. Entre em contato com a instituição para solicitar um novo link de acesso.
                                    </div>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>
                </v-row>

                <v-row v-if="!isFormBlocked">
                    <v-col cols="12" sm="12">
                        <iframe
                            v-if="isPitDocument && content"
                            ref="pitFrame"
                            title="Documento do Plano Individual de Trabalho (PIT)"
                            :srcdoc="content"
                            class="pit-document-frame"
                            @load="resizePitFrame"
                        ></iframe>
                        <div v-else-if="content" v-html="content"></div>
                        <v-alert
                            v-else-if="isPitDocument"
                            type="warning"
                            text
                            dense
                            class="ma-0"
                        >
                            Não foi possível carregar o documento do PIT. Entre em contato com a administração.
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row v-if="model && model.term && !isFormBlocked">
                    <v-col cols="12" sm="12">
                        <a id="term"></a>
                        <!-- RN01: Múltiplas opções de resposta do termo -->
                        <!-- Prioridade: term.term_options > checkbox is_required > institution.term_options -->
                        
                        <!-- Caso 1: Termo tem opções próprias (term_options) -->
                        <v-radio-group
                            v-if="termOptions && termOptions.length > 0"
                            v-model="model.term_option_id"
                            class="ma-2"
                            :disabled="view"
                            @change="onOptionChange"
                        >
                            <v-radio
                                v-for="(opt, i) in termOptions"
                                :key="opt.id || i"
                                :label="opt.label"
                                :value="opt.id"
                                :color="opt.color || (opt.is_valid_acceptance ? 'success' : 'grey')"
                            />
                        </v-radio-group>
                        
                        <!-- Caso 2: Termo obrigatório sem opções próprias (legado - checkbox) -->
                        <v-checkbox
                            v-else-if="model.term.is_required"
                            v-model="model.agree"
                            :label="model.term.label || 'Li e concordo com os termos acima'"
                            color="primary"
                            hide-details
                            class="ma-2"
                            :disabled="view"
                        />
                        
                        <!-- Caso 3: Fallback para opções da instituição (legado) -->
                        <span v-else>
                            <v-radio-group
                                v-if="institutionOptions && institutionOptions.length > 0"
                                v-model="model.term_option_id"
                                row
                                class="ma-2"
                                :disabled="view"
                                @change="onOptionChange"
                            >
                                <v-radio
                                    v-for="(opt, i) in institutionOptions"
                                    :key="opt.id || i"
                                    :label="opt.label"
                                    :value="opt.id"
                                    :color="opt.color"
                                />
                            </v-radio-group>
                        </span>
                    </v-col>
                </v-row>
                <!-- Campo de Justificativa Condicional -->
                <v-row v-if="showJustificationField && !isFormBlocked">
                    <v-col cols="12" sm="12">
                        <a id="justification"></a>
                        <v-textarea
                            v-model="model.justification"
                            label="Justificativa *"
                            :error="!!errors.justification"
                            :error-messages="errors.justification"
                            :disabled="view"
                            :counter="2000"
                            :rules="justificationRules"
                            rows="4"
                            outlined
                            persistent-placeholder
                            placeholder="Informe o motivo da sua decisão..."
                            hint="A justificativa é obrigatória para a opção selecionada (mínimo 10 caracteres)"
                            persistent-hint
                        />
                    </v-col>
                </v-row>
                <!-- Exibir justificativa em modo visualização -->
                <v-row v-if="view && model.justification">
                    <v-col cols="12" sm="12">
                        <v-card outlined class="pa-3">
                            <v-card-subtitle class="pb-1">Justificativa</v-card-subtitle>
                            <v-card-text>{{ model.justification }}</v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>

            <emc-alert-modal text="Após salvar a edição do termo, não será possível editar novamente. Deseja salvar?" v-bind:show.sync="showSave">
                <template v-slot:actions>
                    <v-btn color="primary" @click.prevent.stop="save()" :loading="updating">Salvar<v-icon right dark>mdi-content-save</v-icon></v-btn>
                </template>
            </emc-alert-modal>

        </template>

        <template v-slot:actions>
            <v-btn v-if="!view && !isFormBlocked" color="primary" @click.prevent.stop="showSaveTerm()" >Salvar<v-icon right dark>mdi-content-save</v-icon></v-btn>
        </template>

    </sys-register-base>
</template>

<script>

import { mapActions } from 'vuex'
export default {
    name: "SysRegisterTermSignatureForm",
    data: () => ({
        dialog: false,
        updating: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        model: {},
        content: null,
        showSave: false,
        tokenExpired: false,
        tokenInvalid: false,
        alreadySigned: false,
        justificationRules: [
            v => !v || v.length >= 10 || 'A justificativa deve ter pelo menos 10 caracteres',
            v => !v || v.length <= 2000 || 'A justificativa não pode ter mais de 2000 caracteres'
        ],
    }),
    
    created(){
       this.getData();
    },

    computed: {
        /**
         * RN01: Opções de resposta do termo (prioridade)
         * Retorna as opções específicas do termo, se existirem
         */
        termOptions() {
            const options = this.model?.term?.term_options || this.model?.term?.termOptions;
            if (options && options.length > 0) {
                // Filtrar apenas opções ativas
                return options.filter(opt => opt.active !== false);
            }
            return [];
        },

        /**
         * Opções de resposta da instituição (fallback legado)
         */
        institutionOptions() {
            const options = this.model?.institution?.term_options || this.model?.institution?.termOptions;
            if (options && options.length > 0) {
                return options.filter(opt => opt.active !== false);
            }
            return [];
        },

        /**
         * Retorna todas as opções disponíveis (termo ou instituição)
         */
        availableOptions() {
            // Prioridade: opções do termo > opções da instituição
            if (this.termOptions.length > 0) {
                return this.termOptions;
            }
            return this.institutionOptions;
        },

        /**
         * Retorna a opção selecionada atualmente
         * Busca em termOptions primeiro, depois em institutionOptions
         */
        selectedOption() {
            if (!this.model?.term_option_id) {
                return null;
            }
            
            // Buscar nas opções do termo primeiro
            if (this.termOptions.length > 0) {
                const found = this.termOptions.find(opt => opt.id === this.model.term_option_id);
                if (found) return found;
            }
            
            // Fallback: buscar nas opções da instituição
            if (this.institutionOptions.length > 0) {
                return this.institutionOptions.find(opt => opt.id === this.model.term_option_id);
            }
            
            return null;
        },

        /**
         * Verifica se deve exibir o campo de justificativa
         * RN03: Exibe quando a opção selecionada tem require_justification = true
         */
        showJustificationField() {
            if (this.view) {
                return false;
            }
            if (!this.selectedOption) {
                return false;
            }
            return this.selectedOption.require_justification === true || 
                   this.selectedOption.require_justification === 1;
        },

        /**
         * Verifica se a justificativa é obrigatória e válida
         */
        isJustificationValid() {
            if (!this.showJustificationField) {
                return true;
            }
            const justification = this.model.justification || '';
            return justification.trim().length >= 10;
        },

        /**
         * Indica que o conteúdo é o documento espelho do PIT (HTML completo do
         * extrato). Renderizado em iframe isolado para não vazar o CSS global.
         */
        isPitDocument() {
            return this.model?.term?.content_source === 'pit';
        },

        /**
         * Verifica se o formulário está bloqueado (token expirado, já assinado, etc.)
         */
        isFormBlocked() {
            return this.tokenExpired || this.tokenInvalid || this.alreadySigned;
        },

        /**
         * Mensagem de bloqueio para exibição
         */
        blockMessage() {
            if (this.tokenExpired) {
                return 'Link expirado. Solicite um novo link para assinar o termo.';
            }
            if (this.tokenInvalid) {
                return 'Link inválido. O link de acesso não foi encontrado.';
            }
            if (this.alreadySigned) {
                return 'Este termo já foi assinado anteriormente.';
            }
            return '';
        },
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                this.error = false;
                this.errors = {};
                this.getData();
            }
        },
    },
    props: {
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-database-plus"
        },
        title: {
            type: String,
            default: "Assinatura de Termo"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        signatureId: {
            type: Number,
            required: true,
        },
        view: {
            type: Boolean,
            default: false
        },
        token: {
            type: String,
        },
        accessToken: {
            type: String,
        },
        useTeacherAuth: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('term', ['ActionShowTermSignature', 'ActionShowTermSignatureByTeacher', 'ActionUpdateTermSignature', 'ActionSignByTeacherOwner']),

        getData(){

            if(!this.signatureId){
                return;
            }
            
            this.loading = true;
            this.model = {};
            this.content = null;
            this.message = '';

            let payload = {
                id: this.signatureId,
                token: this.token,
                access_token: this.accessToken,
            }

            const action = this.useTeacherAuth 
                ? this.ActionShowTermSignatureByTeacher 
                : this.ActionShowTermSignature;

            action(payload)
                .then((res) => {
                    this.model          = res.data.signature;
                    this.content        = res.data.content;
                    this.tokenExpired   = false;
                    this.tokenInvalid   = false;
                    this.alreadySigned  = false;
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors || {};
                    
                    // Tratar erros específicos de token (RN01)
                    const errorCode = error.error?.code || error.response?.data?.error?.code;
                    
                    if (errorCode === 'TOKEN_EXPIRED') {
                        this.tokenExpired = true;
                        this.message = 'Link expirado. Solicite um novo link para assinar o termo.';
                    } else if (errorCode === 'INVALID_TOKEN' || errorCode === 'TOKEN_NOT_FOUND') {
                        this.tokenInvalid = true;
                        this.message = 'Link inválido. O link de acesso não foi encontrado.';
                    } else if (errorCode === 'ALREADY_SIGNED') {
                        this.alreadySigned = true;
                        this.message = 'Este termo já foi assinado anteriormente.';
                    } else {
                        this.message = error.message || 'Erro ao carregar o termo.';
                    }
                })
                .finally(() => {
                     this.loading = false;
                     this.updating = false;
                });

        },

        /**
         * Ajusta a altura do iframe do PIT ao conteúdo renderizado (srcdoc é
         * same-origin), evitando scroll interno e barra dupla.
         */
        resizePitFrame() {
            const frame = this.$refs.pitFrame;
            if (!frame) {
                return;
            }

            const doc = frame.contentDocument || frame.contentWindow?.document;
            if (doc?.body) {
                frame.style.height = `${doc.body.scrollHeight}px`;
            }
        },

        /**
         * Callback quando a opção é alterada
         * Limpa a justificativa se a nova opção não exigir
         */
        onOptionChange() {
            if (!this.showJustificationField) {
                this.model.justification = null;
            }
        },

        showSaveTerm()
        {
            if(this.model.term){
                // RN01: Validação considera opções do termo
                const hasTermOptions = this.termOptions && this.termOptions.length > 0;
                const hasInstitutionOptions = this.institutionOptions && this.institutionOptions.length > 0;
                
                // Se há opções (do termo ou instituição), precisa selecionar uma
                if (hasTermOptions || (!this.model.term.is_required && hasInstitutionOptions)) {
                    if (!this.model.term_option_id) {
                        let el = document.createElement('a');
                        el.href="#term";
                        el.click();
                        this.showSnack('Selecione uma das opções de resposta!', true);
                        return;
                    }
                }
                // Se não há opções e é obrigatório, precisa marcar o checkbox
                else if (this.model.term.is_required && !this.model.agree) {
                    let el = document.createElement('a');
                    el.href="#term";
                    el.click();
                    this.showSnack('Informe se está de acordo ou não com o termo!', true);
                    return;
                }
            }

            // Validar justificativa obrigatória (RN03)
            if (this.showJustificationField && !this.isJustificationValid) {
                let el = document.createElement('a');
                el.href = "#justification";
                el.click();
                this.showSnack('A justificativa é obrigatória e deve ter pelo menos 10 caracteres!', true);
                return;
            }

            this.showSave = true;

        },
        
        save()
        {
            this.error = false;
            this.message = '';
            this.updating = true;

            const fields = [
                'id', 'institution_id', 'work_time_id', 'teacher_id', 'user_id_signature',
                'user_id', 'term_id', 'term_signature_status_id', 'term_option_id', 'agree',
                'content', 'note', 'note_user', 'justification'
            ];
            const payload = fields.reduce((acc, key) => {
                if (this.model[key] !== undefined) acc[key] = this.model[key];
                return acc;
            }, {});

            payload.term_signature_status_id = 2;
            payload.token = this.token;
            payload.access_token = this.accessToken;
            payload.content = this.content;

            const action = this.useTeacherAuth 
                ? this.ActionSignByTeacherOwner 
                : this.ActionUpdateTermSignature;

            action(payload)
                .then((res) => {
                    this.message = res.message.success ? res.message.success : res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors || {};
                    
                    // Tratar erros específicos de token na assinatura (RN01)
                    const errorCode = error.error?.code || 
                                      error.response?.data?.error?.code ||
                                      error.response?.data?.error_code;
                    
                    if (errorCode === 'TOKEN_EXPIRED' || errorCode === 'token_expired') {
                        this.tokenExpired = true;
                        this.message = 'Link expirado. Não é possível assinar o termo. Solicite um novo link.';
                    } else if (errorCode === 'TOKEN_REQUIRED' || errorCode === 'token_required') {
                        this.tokenInvalid = true;
                        this.message = 'Token de acesso é obrigatório.';
                    } else if (errorCode === 'TOKEN_INVALID' || errorCode === 'token_invalid') {
                        this.tokenInvalid = true;
                        this.message = 'Token de acesso inválido.';
                    } else if (errorCode === 'ALREADY_SIGNED' || errorCode === 'already_signed') {
                        this.alreadySigned = true;
                        this.message = 'Este termo já foi assinado anteriormente.';
                    } else {
                        this.message = error.message || 'Erro ao salvar a assinatura.';
                    }
                })
                .finally(() => {
                     this.updating = false;
                     this.showSave = false;
                });
        },

        showSnack(message, error){
        
            this.message = '';

            this.$nextTick(() => {
                this.error = error;
                this.message = message;
            });

        },
    }
}
</script>

<style scoped>
.pit-document-frame {
    width: 100%;
    min-height: 480px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background-color: #fff;
}
</style>